var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimatedCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        .circle {\r\n        fill: none;\r\n        stroke: #db3236;\r\n        stroke-width: 3;\r\n        stroke-dasharray: 628;\r\n        stroke-dashoffset: 628;\r\n        animation: drawCircle 0.8s linear forwards;\r\n        }\r\n\r\n        .checkmark {\r\n        stroke: #db3236;\r\n        stroke-width: 4;\r\n        fill: none;\r\n        stroke-dasharray: 100;\r\n        stroke-dashoffset: 100;\r\n        animation: draw 0.5s linear 0.8s forwards;\r\n        }\r\n\r\n        @keyframes drawCircle {\r\n        to {\r\n        stroke-dashoffset: 0;\r\n        }\r\n        }\r\n\r\n        @keyframes draw {\r\n        to {\r\n        stroke-dashoffset: 0;\r\n        }\r\n        }\r\n    ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "circle",
    cx: 50,
    cy: 50,
    r: 40
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "checkmark",
    d: "M25 50 L45 70 L75 30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimatedCheck);
export default __webpack_public_path__ + "static/media/animated-check.eb891e1cd61b3b4c602491397460519f.svg";
export { ForwardRef as ReactComponent };